import gql from 'graphql-tag';

export const USER_SKILL_FRAGMENT = `
  __typename
  _id
  skillId
  userId
  improve
  improveNotes
  isShareable
  like
  level
  origin
  createdAt
  deleted
  updatedAt
  proofPointId
  suggestion {
    suggestedBy {
      _id
      profile {
         name
      }
    }
    suggestedAction
    isImprove
    level
    comment
  }
  managerAssessment {
    confirmedAt
    status
  }
  skill {
    _id
    type
    trends {
      _id
      trendIcon
      replaceability
      demand
    }
    industry {
      _id
      name
    }
    synonym(policiesPreset: $policiesPreset) {
      _id
      skillId
      synonymId
      synonymLang
      synonymString
      synonymLevelDescriptions {
        _id
        level
        description
      }
      companySpecific {
        _id
        isLogoVisible
        definition
      }
    }
  }
`;

export const GET_VIEWER_SKILLS = gql`
  query GET_VIEWER_SKILLS($policiesPreset: PoliciesPresetInput) {
    viewerSkills {
      ${USER_SKILL_FRAGMENT}
    }
  }
`;
